document.addEventListener('DOMContentLoaded', () => {

  let currentOpen = null;

  function isClickInsideElement(event, className) {
    let target = event.target;
    while (target != null) {
      if (target.classList.contains(className)) {
        return true;
      }
      target = target.parentElement;
    }
    return false;
  }

  document.querySelectorAll('.c-dropdown-filter__btn').forEach(button => {
    button.addEventListener('click', function () {
      // const contentId = 'content-' + this.id.slice(-1);
      const contentId = this.getAttribute('data-target');
      const contentDiv = document.getElementById(contentId);
      const isOpen = !contentDiv.hasAttribute('hidden');

      if (currentOpen && currentOpen !== contentDiv) {
        currentOpen.setAttribute('hidden', '');
        updateAriaExpanded(currentOpen.previousElementSibling, false);
      }

      if (isOpen) {
        contentDiv.setAttribute('hidden', '');
        updateAriaExpanded(this, false);
      } else {
        contentDiv.removeAttribute('hidden');
        updateAriaExpanded(this, true);
        currentOpen = contentDiv;
      }
    });
  });

  function updateAriaExpanded(element, state) {
    element.setAttribute('aria-expanded', state);
  }

  // Event listener for ESC key press
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && currentOpen) {
      currentOpen.setAttribute('hidden', '');
      updateAriaExpanded(currentOpen.previousElementSibling, false);
      currentOpen = null;
    }
  });

  window.addEventListener('click', function (event) {
    if (!isClickInsideElement(event, 'c-dropdown-filter__content') && !event.target.matches('.c-dropdown-filter__btn')) {
      if (currentOpen) {
        currentOpen.setAttribute('hidden', '');
        updateAriaExpanded(currentOpen.previousElementSibling, false);
        currentOpen = null;
      }
    }
  }, true);
});